"use client";

import { c as _c } from "react/compiler-runtime";
import { DayPicker, type DayPickerProps } from "react-day-picker";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

/** DayPicker calendar styled with the same semantic tokens as our shadcn controls. */
export function Calendar(t0) {
  const $ = _c(16);
  let className;
  let classNames;
  let components;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      classNames,
      components,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = classNames;
    $[3] = components;
    $[4] = props;
  } else {
    className = $[1];
    classNames = $[2];
    components = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("rounded-lg border bg-background p-3 text-foreground", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== classNames) {
    t2 = {
      months: "relative",
      month: "space-y-2",
      month_caption: "flex h-8 items-center justify-center",
      caption_label: "text-sm font-medium",
      nav: "absolute inset-x-0 top-0 flex justify-between",
      button_previous: "flex size-8 items-center justify-center rounded-md hover:bg-accent focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-30",
      button_next: "flex size-8 items-center justify-center rounded-md hover:bg-accent focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-30",
      month_grid: "w-full table-fixed border-collapse",
      weekday: "h-8 text-center text-xs font-normal text-muted-foreground",
      day: "p-0 text-center text-sm",
      day_button: "mx-auto flex size-8 items-center justify-center rounded-md hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none",
      selected: "[&>button]:bg-primary [&>button]:text-primary-foreground [&>button]:hover:bg-primary/90",
      today: "[&>button]:ring-1 [&>button]:ring-primary",
      outside: "text-muted-foreground opacity-50",
      disabled: "text-muted-foreground opacity-30",
      hidden: "invisible",
      ...classNames
    };
    $[7] = classNames;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== components) {
    t3 = {
      Chevron: _temp,
      ...components
    };
    $[9] = components;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== props || $[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t4 = <DayPicker showOutsideDays={true} className={t1} classNames={t2} components={t3} {...props} />;
    $[11] = props;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}
function _temp(t0) {
  const {
    orientation
  } = t0;
  return orientation === "left" ? <ChevronLeft className="size-4" /> : <ChevronRight className="size-4" />;
}